import moment from 'moment'
import { store } from '../store'
import { SET_OFFERS } from '../utils/constants'
import { showFile, showXlsxFile, showCSVFile } from './beneficiary-transfers.service'
import uuid from 'uuid'
import http from '../api/api'
import config from '../api/constants'

const getAllAccounts = async () => {
  try {
    const reqParams = {
      requestId: 'ACCOUNTDETAILS',
      accountType: 'S',
    }
    const response = await http.post(config.apiRoute.GET_ACCOUNTS, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getSIList = async (data) => {
  try {
    const reqParams = {
      requestId: 'GETSILIST',
      module: 'STANDINGINSTRUCTION',
      srcAcc: data,
    }
    const response = await http.post(config.apiRoute.GET_SI_LIST, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getAccountDetails = async (accountNumber) => {
  const { app } = store.getState()
  try {
    const reqParams = {
      requestId: 'ACCOUNTDETAILS',
      accountNo: accountNumber,
      brnCode: app.profile.branchCode,
    }
    const accountDetails = await http.post(config.apiRoute.GET_CASA_ACCOUNT_DETAILS, reqParams)
    return accountDetails.data
  } catch (err) {
    throw err.response.data
  }
}

const getCurrentMonthTransactions = async (accountNumber, customerId) => {
  const { app } = store.getState()
  const toDate = moment().format('YYYY-MM-DD')
  const fromDate = moment().startOf('month').format('YYYY-MM-DD')
  try {
    const reqParams = {
      accountNo: accountNumber,
      fromDate,
      requestId: 'FULLSTATEMENT',
      toDate,
      brnCode: app.profile.branchCode,
    }
    const transactionList = await http.post(config.apiRoute.GET_ACCOUNT_STATEMENT, reqParams)
    return transactionList.data
  } catch (err) {
    throw err.response.data
  }
}

const getTransactions = async (data) => {
  const { app } = store.getState()
  const toDateFormatted = moment(data?.toDate).format('YYYY-MM-DD')
  const fromDateFormatted = moment(data?.fromDate).format('YYYY-MM-DD')
  try {
    const reqParams = {
      accountNo: data?.accountNumber,
      fromDate: fromDateFormatted,
      toDate: toDateFormatted,
      requestId: 'FULLSTATEMENT',
      brnCode: app.profile.branchCode,
    }
    const transactionList = await http.post(config.apiRoute.GET_ACCOUNT_STATEMENT, reqParams)
    return transactionList.data
  } catch (err) {
    throw err.response.data
  }
}

const getTransactionSearch = async (data) => {
  const { app } = store.getState()
  const toDateFormatted = moment(data?.toDate).format('YYYY-MM-DD')
  const fromDateFormatted = moment(data?.fromDate).format('YYYY-MM-DD')
  const reqParams = {
    accountNo: data?.accountNumber,
    amount: parseFloat(data?.amount),
    trnsDesc: data?.trnsDesc,
    debitOrCredit: data?.transType,
    referenceNo: data?.referenceNo,
    fromDate: fromDateFormatted,
    toDate: toDateFormatted,
    requestId: 'FULLSTATEMENT',
    page: '',
    brnCode: app.profile.branchCode,
  }
  try {
    const transactionList = await http.post(config.apiRoute.GET_ACCOUNT_STATEMENT, reqParams)
    return transactionList.data
  } catch (err) {
    throw err.response.data
  }
}

const getTransactionsForDate = async (data) => {
  const { app } = store.getState()
  const toDateFormatted = moment(data?.toDate).format('YYYY-MM-DD')
  const fromDateFormatted = moment(data?.fromDate).format('YYYY-MM-DD')
  const reqParams = {
    accountNo: data?.accountNumber,
    fromDate: fromDateFormatted,
    toDate: toDateFormatted,
    requestId: 'FULLSTATEMENT',
    branchCode: app.profile.branchCode,
  }
  try {
    const transactionList = await http.post(config.apiRoute.GET_ACCOUNT_STATEMENT, reqParams)
    return transactionList.data
  } catch (err) {
    throw err.response.data
  }
}

const getCurrentAndPreviousMonthTransactions = async (accountNumber) => {
  const { app } = store.getState()
  const toDate = moment().format('YYYY-MM-DD')
  // const fromDate = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
  const fromDate = moment().subtract(1, 'month').format('YYYY-MM-DD')
  try {
    const reqParams = {
      accountNo: accountNumber,
      fromDate,
      requestId: 'FULLSTATEMENT',
      toDate,
      branchCode: app.profile.branchCode,
    }
    const transactionList = await http.post(config.apiRoute.GET_ACCOUNT_STATEMENT, reqParams)
    return transactionList.data
  } catch (err) {
    throw err.response.data
  }
}

const getLast2MonthTransactions = async (accountNumber, custid, substractmonth) => {
  const { app } = store.getState()
  // const fromDate = moment().subtract(substractmonth, 'month').startOf('month').format('YYYY-MM-DD')
  // const toDate = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
  const fromDate = moment().subtract(substractmonth, 'month').format('YYYY-MM-DD')
  const toDate = moment().format('YYYY-MM-DD')
  try {
    const reqParams = {
      accountNo: accountNumber,
      fromDate,
      requestId: 'FULLSTATEMENT',
      toDate,
      branchCode: app.profile.branchCode,
    }
    const transactionList = await http.post(config.apiRoute.GET_ACCOUNT_STATEMENT, reqParams)
    return transactionList.data
  } catch (err) {
    throw err.response.data
  }
}

const getLast3MonthTransactions = async (accountNumber, custid, substractmonth) => {
  const { app } = store.getState()
  // const fromDate = moment().subtract(substractmonth, 'month').startOf('month').format('YYYY-MM-DD')
  // const toDate = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
  const fromDate = moment().subtract(substractmonth, 'month').format('YYYY-MM-DD')
  const toDate = moment().format('YYYY-MM-DD')
  try {
    const reqParams = {
      accountNo: accountNumber,
      fromDate,
      requestId: 'FULLSTATEMENT',
      toDate,
      branchCode: app.profile.branchCode,
    }
    const transactionList = await http.post(config.apiRoute.GET_ACCOUNT_STATEMENT, reqParams)
    return transactionList.data
  } catch (err) {
    throw err.response.data
  }
}
const getDailyTransactionDetails = async (accountNumber) => {
  const { app } = store.getState()
  const toDate = moment().format('YYYY-MM-DD')
  const fromDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
  try {
    const reqParams = {
      accountNo: accountNumber,
      fromDate,
      requestId: 'FULLSTATEMENT',
      toDate,
      branchCode: app.profile.branchCode,
    }
    const transactionList = await http.post(config.apiRoute.GET_ACCOUNT_STATEMENT, reqParams)
    return transactionList.data
  } catch (err) {
    throw err.response.data
  }
}
const getLast10Transactions = async (accountDetails) => {
  try {
    const reqParams = {
      accountNo: accountDetails.accountNo,
      requestId: 'MINISTATEMENT',
    }
    const response = await http.post(config.apiRoute.GET_ACCOUNT_MINI_STATEMENT, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getOffers = async () => {
  try {
    const reqParams = {
      requestId: 'OFFERS',
      module: 'Information',
    }
    const listOfOffers = await http.post(config.apiRoute.GET_OFFERS, reqParams)
    store.dispatch({ type: SET_OFFERS, payload: listOfOffers.data.offers })
    return listOfOffers.data
  } catch (err) {
    throw err.response.data
  }
}

const getPDFStatement = async (fromDate, toDate, custId, data) => {
  const { account, app } = store.getState()
  try {
    const reqParams = {
      accountNo: account.currentItem.accountNo,
      fromDate,
      toDate,
      brnCode: app.profile.branchCode,
      requestId: 'FULLSTATEMENT',
      format: data,
      page: 0,
      format: data
    }
    const transactionList = await http.post(config.apiRoute.GET_PDF_REPORT, reqParams,
      { responseType: 'arraybuffer' },
    )
    if (data === 'PDF') {
      showFile(transactionList.data, 'pdfStatement_' + uuid.v4())
    } else if (data === 'EXCEL') {
      showXlsxFile(transactionList.data, 'Statement_' + uuid.v4())
    } else {
      showCSVFile(transactionList.data, 'Statement_' + uuid.v4())
    }
    return transactionList.data
  } catch (err) {
    throw err.response.data
  }
}

const AccountsService = {
  getAllAccounts,
  getSIList,
  getAccountDetails,
  getCurrentMonthTransactions,
  getTransactions,
  getTransactionSearch,
  getTransactionsForDate,
  getCurrentAndPreviousMonthTransactions,
  getLast2MonthTransactions,
  getLast3MonthTransactions,
  getDailyTransactionDetails,
  getLast10Transactions,
  getOffers,
  getPDFStatement,
}

export default AccountsService
